import { z } from 'zod'

import { PUBLIC_INSURANCES } from './constants'

export const publicHealthSchema = z.object({
  previous_insurer: z.enum([
    'not_insured',
    'insurerer_not_listed',
    ...PUBLIC_INSURANCES.map((insurance) => insurance.key),
  ]),

  employment_status: z.enum([
    'permanently_employed',
    'civil_servant',
    'student',
    'apprentice',
    'self_employed',
    'retired',
    'other',
  ]),

  income: z.enum(['less_than_30k', '30k_to_50k', '50k_to_74k', 'more_than_74k']),

  include_kids: z.boolean(),
})
